import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-586e5eb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "team-name-text" }, "协作空间", -1))


const __default__ = {
  name: 'TeamHeadInfo'
}

import { PropType, ref, toRefs, onBeforeMount, watch, computed } from 'vue'
import TeamInputEditor from '../inputEditor'
import { updateGroup, updateGroupName } from '@teams/common/api'
// import usePreference from '@teams/common/hooks/usePreference'
import handleResponseError from '@teams/common/hooks/useResponseError'
import useTeamShare from '@teams/common/hooks/useTeamShare'
import { useUserStore } from '@/store/user'
import Icon from '@teams/common/components/icon'
// const preference = usePreference()


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  groupId: Number,
  teamColor: String,
  teamName: String,
  descName: String,
  descColor: String,
  isEase: Boolean,
  onUpdate: {
    type: Function as PropType<
      (key: string, ...args: unknown[]) => Promise<unknown> | unknown
    >,
    default: () => null
  },
  allowEditName: {
    type: Boolean,
    default: true
  },
  allowEditDesc: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props


const { teamName, descName } = toRefs(props)
const teamNameLabel = ref(teamName?.value)
const userStore = useUserStore()
const descNameLabel = ref<string>()
const showEmptyMsg = computed(() =>
  ['Administrator', 'Owner'].includes(userStore.role.key as string)
)
// 私密空间、邀请信息相关
const { hasInviteInfo, inviteInfo } = useTeamShare()

onBeforeMount(() => {
  setDesc(descName?.value || inviteInfo.value.desc)
})
watch(
  () => userStore.role,
  () => {
    setDesc(descName?.value || inviteInfo.value.desc)
  }
)
const setDesc = (desc?: string) => {
  if (!desc && showEmptyMsg.value) {
    descNameLabel.value = '暂无团队简介'
  } else {
    descNameLabel.value = desc
  }
}
const updateTeamName = async (params: {
  name: string
  color: string
  next: () => void
}) => {
  const { name, color } = params
  const groupId = props.groupId
  if (groupId) {
    try {
      const [info] = await Promise.all([
        // 修改团队名称
        updateGroupName(groupId, name)
        // 修改团队名称颜色
        /* preference.setCurrentThemeStyle({
          styles: { 'PC-group-head-name-color': color }
        }) */
      ])
      teamNameLabel.value = name
      await props.onUpdate('name', { name })
    } catch (e) {
      handleResponseError(e)
      return false
    }
  }
}

const updateTeamDesc = async (params: {
  name: string
  color: string
  next: () => void
}) => {
  const { name, color } = params
  const groupId = props.groupId
  if (groupId) {
    try {
      await Promise.all([
        // 修改团队简介
        updateGroup({
          group_id: groupId,
          key: 'desc',
          value: name
        })

        // 修改团队简介颜色
        /* preference.setCurrentThemeStyle({
          styles: { 'PC-group-head-desc-color': color }
        }) */
      ])
      setDesc(name)
      await props.onUpdate('desc')
    } catch (e) {
      handleResponseError(e)
      return false
    }
  }
}

const goToIndex = () => {
  window.location.href = window.location.origin
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['team-info', { 'team-info--ease': __props.isEase || false }])
  }, [
    (props.groupId || _unref(hasInviteInfo))
      ? (_openBlock(), _createBlock(_unref(TeamInputEditor), {
          key: 0,
          showEmojiPanel: false,
          name: teamNameLabel.value || _unref(inviteInfo).invite_link.group_name || '暂无团队名',
          maxLength: 15,
          className: "team-name",
          onConfirm: updateTeamName,
          allowEdit: __props.allowEditName
        }, null, 8, ["name", "allowEdit"]))
      : _createCommentVNode("", true),
    (!props.groupId && !_unref(hasInviteInfo))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          className: "team-name",
          onClick: goToIndex,
          style: {"cursor":"pointer"}
        }, [
          _createVNode(_unref(Icon), {
            name: "teamSpaceLogo",
            fill: "transparent",
            size: 36
          }),
          _hoisted_1
        ]))
      : _createCommentVNode("", true),
    (props.groupId || _unref(hasInviteInfo))
      ? (_openBlock(), _createBlock(_unref(TeamInputEditor), {
          key: 2,
          name: descNameLabel.value,
          maxLength: 40,
          className: "team-desc",
          onConfirm: updateTeamDesc,
          allowEdit: __props.allowEditDesc
        }, null, 8, ["name", "allowEdit"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})